// Combobox/Autocomplete (ARIA) - source depuis .ac__menu > .ac__option
(() => {
    let uid = 0;
    function highlight(text, query) {
        if (!query) return text;
        const re = new RegExp(query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'ig');
        return text.replace(re, (m) => `<mark>${m}</mark>`);
    }

    document.querySelectorAll('[data-autocomplete]').forEach(root => {
        const input = root.querySelector('.ac__input');
        const menu  = root.querySelector('.ac__menu');
        if (!input || !menu) return;

        const id = `ac-${++uid}`;
        const menuId = `${id}-listbox`;
        input.setAttribute('role','combobox');
        input.setAttribute('aria-autocomplete','list');
        input.setAttribute('aria-expanded','false');
        input.setAttribute('aria-controls', menuId);
        menu.setAttribute('id', menuId);
        menu.setAttribute('role','listbox');

        let activeIndex = -1;

        function options() { return [...menu.querySelectorAll('.ac__option')]; }
        function open() { root.classList.add('is-open'); input.setAttribute('aria-expanded','true'); document.addEventListener('click', onDoc, { capture:true }); }
        function close(){ root.classList.remove('is-open'); input.setAttribute('aria-expanded','false'); activeIndex=-1; document.removeEventListener('click', onDoc, { capture:true }); }
        function onDoc(e){ if (!root.contains(e.target)) close(); }

        function filter(){
            const q = input.value.trim();
            let any = false;
            options().forEach(opt => {
                const label = opt.getAttribute('data-label') || opt.textContent.trim();
                const match = q === '' || label.toLowerCase().includes(q.toLowerCase());
                opt.style.display = match ? '' : 'none';
                if (match) any = true;
                // highlight
                const base = opt.getAttribute('data-label') || opt.textContent.trim();
                opt.innerHTML = `<span class="ac__mark">${highlight(base, q)}</span>`;
            });
            let empty = menu.querySelector('.ac__empty');
            if (!any) {
                if (!empty) { empty = document.createElement('div'); empty.className='ac__empty'; empty.textContent='Aucun résultat'; menu.appendChild(empty); }
            } else empty?.remove();
        }

        function move(delta){
            const visible = options().filter(o => o.style.display !== 'none');
            if (!visible.length) return;
            activeIndex = (activeIndex + delta + visible.length) % visible.length;
            visible.forEach((o,i) => o.setAttribute('aria-selected', String(i===activeIndex)));
            visible[activeIndex].scrollIntoView({ block:'nearest' });
        }
        function choose(opt){
            const val = opt.getAttribute('data-value') || opt.textContent.trim();
            input.value = val;
            close();
        }

        input.addEventListener('focus', () => { open(); filter(); });
        input.addEventListener('input', () => { if (!root.classList.contains('is-open')) open(); filter(); });
        input.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowDown') { e.preventDefault(); move(1); }
            else if (e.key === 'ArrowUp') { e.preventDefault(); move(-1); }
            else if (e.key === 'Enter') {
                e.preventDefault();
                const vis = options().filter(o => o.style.display !== 'none');
                if (!vis.length) return;
                const opt = activeIndex >= 0 ? vis[activeIndex] : vis[0];
                if (opt) choose(opt);
            } else if (e.key === 'Escape') close();
        });

        menu.addEventListener('click', (e) => {
            const opt = e.target.closest('.ac__option'); if (!opt) return;
            choose(opt);
        });

        // init
        filter(); menu.style.display = 'none';
    });
})();
